import { opponentsById } from '@/data/opponents'
import { createScoreSeries } from '@/utils/createSeries'
import { calcAverages, calcFilteredAverages } from '@/utils/emotionSeriesUtils'

export default {
  namespaced: true,
  state: {
    selectedOpponentId: 'JORGE_MASVIDAL',
    userEmotionSeries: [],
    captureDuration: 11.5,
    totalCaptures: 80,
    maximumScore: 10000,
    userShareImageLocal: null,
    userShareImageHosted: null,
    emotions: [
      { name: 'anger', alias: 'anger', display: true, image: require('@/assets/img/emoticon-anger-2.svg') },
      { name: 'contempt', alias: 'contempt', display: false },
      { name: 'disgust', alias: 'disgust', display: true },
      { name: 'fear', alias: '', display: false },
      { name: 'happiness', alias: 'confidence', display: true, image: require('@/assets/img/emoticon-happiness-2.svg') },
      { name: 'neutral', alias: 'neutral', display: true, image: require('@/assets/img/emoticon-neutral-2.svg') },
      { name: 'sadness', alias: '', display: false },
      { name: 'surprise', alias: 'shock', display: true }
    ]
  },
  getters: {
    opponent (state) {
      return opponentsById[state.selectedOpponentId]
    },
    userEmotionSeriesFiltered (state, getters) {
      if (!state.userEmotionSeries.length) return []
      return state.userEmotionSeries.map(series => getters.emotionsToDisplay.map(i => series[i]))
    },
    opponentEmotionSeriesFiltered (_, getters) {
      return getters.opponent.emotionSeries.map(series => getters.emotionsToDisplay.map(i => series[i]))
    },
    userEmotionAverages (state) {
      if (!state.userEmotionSeries.length) return []
      return calcAverages(state.userEmotionSeries)
    },
    opponentEmotionAverages (_, getters) {
      return calcAverages(getters.opponent.emotionSeries)
    },
    userEmotionAveragesFiltered (state) {
      if (!state.userEmotionSeries.length) return []
      return calcFilteredAverages(state.userEmotionSeries)
    },
    opponentEmotionAveragesFiltered (_, getters) {
      return calcFilteredAverages(getters.opponent.emotionSeries)
    },
    userScoreSeries (state, getters) {
      if (!state.userEmotionSeries.length) return []
      return createScoreSeries(state.userEmotionSeries, getters.opponent.emotionSeries)
    },
    userScoreSeriesAdjusted (state, getters) {
      if (!getters.userScoreSeries.length) return []
      return getters.userScoreSeries.map(val => val * state.maximumScore / 100)
    },
    userScoreSeriesAdjustedCumulative (_, getters) {
      if (!getters.userScoreSeriesAdjusted.length) return []
      return getters.userScoreSeriesAdjusted.reduce((a, _, i) => { a[i] = i !== 0 ? a[i] + a[i - 1] : a[i]; return a }, getters.userScoreSeriesAdjusted)
    },
    userScore (_, getters) {
      return getters.userScoreSeries.reduce((a, val) => (a + val), 0) / 100
    },
    userScoreAdjusted (state, getters) {
      return getters.userScore * state.maximumScore
    },
    userWonGame (_, getters) {
      return getters.userScore > getters.opponent.threshold
    },
    emotionsToDisplay (state) {
      return state.emotions.reduce((a, emotion, i) => {
        if (emotion.display) a.push(i)
        return a
      }, [])
    },
    emotionsFiltered (state, getters) {
      return getters.emotionsToDisplay.map(i => state.emotions[i])
    }
  },
  mutations: {
    setTotalCaptures (state, value) {
      state.totalCaptures = value
    },
    setSelectedOpponentId (state, value) {
      state.selectedOpponentId = value
    },
    setUserEmotionSeries (state, value) {
      state.userEmotionSeries = value
    },
    setUserShareImageLocal (state, value) {
      state.userShareImageLocal = value
    },
    setUserShareImageHosted (state, value) {
      state.userShareImageHosted = value
    }
  }
}
